import React from 'react';
import {createRoot} from "react-dom/client";
import {Provider} from 'react-redux';
import App from './App';
import store from './store';
import { LicenseInfo } from '@mui/x-license';
// noinspection ES6UnusedImports
import {AuthProvider} from "./provider/AuthProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {LocalizationProvider} from "@mui/x-date-pickers";
import Theme from "./theme";

// @ts-ignore
const root = createRoot(document.getElementById('root'));


LicenseInfo.setLicenseKey("e27e9fb3904f916c6f233843511a9e9dTz0xMjkwMTQsRT0xODA5ODIwNzk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI=");

root.render(
    <AuthProvider>
        <Provider store={store}>
            <Theme>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"sl"}>
                    <App/>
                </LocalizationProvider>
            </Theme>
        </Provider>
    </AuthProvider>
);

